/** Client home meta description - max ~125 chars for social previews. */
export const CLIENT_HOME_OG_DESCRIPTION =
  'Hire expert global consultants on VirtUp. Explore profiles, seamless scheduling, collaboration, and lasting relationships.';

/** Consultant home meta description - max ~125 chars for social previews. */
export const CONSULTANT_HOME_OG_DESCRIPTION =
  'Become a consultant on VirtUp. Reach global clients, control your pricing and workflow, collaborate, and get paid instantly.';

/** Root URL meta (e.g. https://virtup-dev.azurewebsites.net). */
export const ROOT_OG_TITLE =
  'Find and Book Expert Consultants | VirtUp';
export const ROOT_OG_DESCRIPTION =
  'VirtUp is your expert consultation platform. Connect and grow with professionals-book consultants, collaborate, and explore.';

/** Facebook App ID for Open Graph (fb:app_id). */
export const FB_APP_ID = '339246048422004';

/** Default OG image (root / career / marketing / fallback) - logo card for social previews. */
export const DEFAULT_OG_IMAGE_URL = '/image/virtup-og.png';
export const OG_IMAGE_ALT = ROOT_OG_TITLE;

/** Client home OG screenshot (hero). */
export const CLIENT_OG_IMAGE_PATH = '/image/virtup-og-home-client.png';
export const CLIENT_OG_IMAGE_WIDTH = 1200;
export const CLIENT_OG_IMAGE_HEIGHT = 630;
export const CLIENT_OG_IMAGE_ALT =
  "VirtUp client home - Can't find the right consultant? They are on VirtUp!";

/** Consultant home OG screenshot (hero). */
export const CONSULTANT_OG_IMAGE_PATH = '/image/virtup-og-home-consultant.png';
export const CONSULTANT_OG_IMAGE_WIDTH = 1200;
export const CONSULTANT_OG_IMAGE_HEIGHT = 630;
export const CONSULTANT_OG_IMAGE_ALT =
  'VirtUp consultant home - Choose Creative Freedom Over Burnout. Become a Consultant on VirtUp.';
